// src/services/dataPersistence/index.ts
// Main entry point for the data persistence system

import { DataSyncService } from './dataSync';
import { ConversationService } from './conversationService';  
import { ItineraryService } from './itineraryService';
import { MapStateService } from './mapStateService';

// Export type definitions
export * from './types';

// Initialize singleton services
const dataSyncService = DataSyncService.getInstance();
const conversationService = new ConversationService(dataSyncService);
const itineraryService = new ItineraryService(dataSyncService);
const mapStateService = new MapStateService(dataSyncService);

// Export initialized services
export {
  dataSyncService,
  conversationService,
  itineraryService,
  mapStateService
};

// Initialize the data system with current user (can be anonymous)
export function initializeDataSystem(userId: string = 'anonymous'): void {
  dataSyncService.initialize(userId);
  console.log('[DataPersistence] System initialized for user:', userId);
}

// Save data explicitly (useful for testing)
export function saveData(): boolean {
  return dataSyncService.saveToLocalStorage();
}

// Load data explicitly (useful for testing)
export function loadData(): boolean {
  return dataSyncService.loadFromLocalStorage();
}

// Clear all data
export function clearAllData(): void {
  console.log('[Index] - Clearing all data...');
  dataSyncService.clearAllData();
}

// Export service classes for custom initialization
export {
  DataSyncService
  //,ChatHistoryService,
  //LocationDataService
};

/* // Initialize the data system with current user (can be anonymous)
export function initializeDataSystem(userId: string = 'anonymous'): void {
  dataSyncService.initialize(userId);
  console.log('[DataPersistence] System initialized for user:', userId);
}

// Save data explicitly (useful for testing)
export function saveData(): boolean {
  return dataSyncService.saveToLocalStorage();
}

// Load data explicitly (useful for testing)
export function loadData(): boolean {
  return dataSyncService.loadFromLocalStorage();
}

// Clear all data
export function clearAllData(): void {
  dataSyncService.clearAllData();
}
 */